import { createAction } from '@reduxjs/toolkit';

// AuthenticationSlice
export const authenticateTowardsApiInitialize = createAction(
  'api/authentication/login/init',
);
export const authenticateTowardsApiError = createAction(
  'api/authentication/login/error',
);
export const authenticateTowardsApiSuccess = createAction(
  'api/authentication/login/success',
);

// ContentSlice
export const removeContentsFromStore = createAction(
  'api/content/removeFromStore',
);

// CommentSlice
export const getAllCommentsForHearingInitialize = createAction(
  'api/comment/getForHearing/init',
);
export const getAllCommentsForHearingSuccess = createAction(
  'api/comment/getForHearing/success',
);
export const getAllCommentsForHearingError = createAction(
  'api/comment/getForHearing/error',
);
export const getPaginatedCommentsForHearingInitialize = createAction(
  'api/comment/getPaginatedForHearing/init',
);
export const getPaginatedCommentsForHearingSuccess = createAction(
  'api/comment/getPaginatedForHearing/success',
);
export const getPaginatedCommentsForHearingError = createAction(
  'api/comment/getPaginatedForHearing/error',
);

// FieldTemplate
export const createFieldTemplateInitialize = createAction(
  'api/fieldTemplate/create/init',
);
export const createFieldTemplateSuccess = createAction(
  'api/fieldTemplate/create/success',
);
export const createFieldTemplateError = createAction(
  'api/fieldTemplate/create/error',
);
export const updateFieldTemplateInitialize = createAction(
  'api/fieldTemplate/update/init',
);
export const updateFieldTemplateSuccess = createAction(
  'api/fieldTemplate/update/success',
);
export const updateFieldTemplateError = createAction(
  'api/fieldTemplate/update/error',
);
export const deleteFieldTemplateInitialize = createAction(
  'api/fieldTemplate/delete/init',
);
export const deleteFieldTemplateSuccess = createAction(
  'api/fieldTemplate/delete/success',
);
export const deleteFieldTemplateError = createAction(
  'api/fieldTemplate/delete/error',
);

//GlobalContent
export const getLatestGlobalContentOfTypeInitialize = createAction(
  'api/globalContent/getLatestOfType/init',
);
export const getLatestGlobalContentOfTypeSuccess = createAction(
  'api/globalContent/getLatestOfType/success',
);
export const getLatestGlobalContentOfTypeError = createAction(
  'api/globalContent/getLatestOfType/error',
);
export const createGlobalContentInitialize = createAction(
  'api/globalContent/create/init',
);
export const createGlobalContentSuccess = createAction(
  'api/globalContent/create/success',
);
export const createGlobalContentError = createAction(
  'api/globalContent/create/error',
);
export const removeGlobalContentWithIdFromStore = createAction(
  'api/globalContent/removeFromStore',
);

//GlobalContentType
export const getAllGlobalContentTypesInitialize = createAction(
  'api/globalContentType/getAll/init',
);
export const getAllGlobalContentTypesSuccess = createAction(
  'api/globalContentType/getAll/success',
);

// HearingSlice
export const createHearingInitialize = createAction('api/hearing/create/init');
export const createHearingSuccess = createAction('api/hearing/create/success');
export const deleteHearingInitialize = createAction('api/hearing/delete/init');
export const deleteHearingSuccess = createAction('api/hearing/delete/success');
export const deleteHearingError = createAction('api/hearing/delete/error');
export const forceDeleteHearingInitialize = createAction(
  'api/hearing/forceDelete/init',
);
export const forceDeleteHearingSuccess = createAction(
  'api/hearing/forceDelete/success',
);
export const forceDeleteHearingError = createAction(
  'api/hearing/forceDelete/error',
);
export const getHearingInitialize = createAction('api/hearing/get/init');
export const getHearingSuccess = createAction('api/hearing/get/success');
export const getHearingError = createAction('api/hearing/get/error');
export const getAllHearingsInitialize = createAction(
  'api/hearings/getAll/init',
);
export const getAllHearingsSuccess = createAction(
  'api/hearings/getAll/success',
);
export const getAllHearingsError = createAction('api/hearings/getAll/error');
export const getPaginatedHearingsInitialize = createAction(
  'api/hearings/getPaginated/init',
);
export const getPaginatedHearingsSuccess = createAction(
  'api/hearings/getPaginated/success',
);
export const getPaginatedHearingsError = createAction(
  'api/hearings/getPaginated/error',
);
export const getVersionInitialize = createAction('api/version/init');
export const getVersionSuccess = createAction('api/version/success');
export const getVersionError = createAction('api/version/error');
export const updateHearingInitialize = createAction('api/hearing/update/init');
export const updateHearingSuccess = createAction('api/hearing/update/success');
export const updateHearingError = createAction('api/hearing/update/error');

export const updateFieldContentAutoSaveInitialize = createAction(
  'api/hearing/update/fieldContentAutoSave/init',
);
export const updateFieldContentInitialize = createAction(
  'api/hearing/update/fieldContent/init',
);
export const updateFieldContentSuccess = createAction(
  'api/hearing/update/fieldContent/success',
);
export const updateFieldContentError = createAction(
  'api/hearing/update/fieldContent/error',
);

export const createCommentContentInitialize = createAction(
  'api/hearing/create/commentContent/init',
);
export const createCommentContentSuccess = createAction(
  'api/hearing/create/commentContent/success',
);
export const createCommentContentError = createAction(
  'api/hearing/create/commentContent/error',
);

export const updateCommentContentInitialize = createAction(
  'api/hearing/update/commentContent/init',
);
export const updateCommentContentSuccess = createAction(
  'api/hearing/update/commentContent/success',
);
export const updateCommentContentError = createAction(
  'api/hearing/update/commentContent/error',
);

export const updateCommentInitialize = createAction(
  'api/hearing/update/comment/init',
);
export const updateCommentSuccess = createAction(
  'api/hearing/update/comment/success',
);
export const updateCommentError = createAction(
  'api/hearing/update/comment/error',
);

export const removeCommentsFromStore = createAction(
  'api/comment/removeFromStore',
);

export const uploadReviewersInitialize = createAction(
  'api/hearing/uploadReviewers/init',
);
export const uploadReviewersSuccess = createAction(
  'api/hearing/uploadReviewers/success',
);

export const uploadCsvInviteesInitialize = createAction(
  'api/hearing/uploadCsvInvitees/init',
);
export const uploadCsvInviteesSuccess = createAction(
  'api/hearing/uploadCsvInvitees/success',
);

export const uploadExcelInviteesInitialize = createAction(
  'api/hearing/uploadExcelInvitees/init',
);
export const uploadExcelInviteesSuccess = createAction(
  'api/hearing/uploadExcelInvitees/success',
);

export const uploadPersonalInviteesInitialize = createAction(
  'api/hearing/uploadPersonalInvitees/init',
);
export const uploadPersonalInviteesSuccess = createAction(
  'api/hearing/uploadPersonalInvitees/success',
);

export const uploadInvitationGroupInviteesInitialize = createAction(
  'api/hearing/uploadInvitationGroupInvitees/init',
);
export const uploadInvitationGroupInviteesSuccess = createAction(
  'api/hearing/uploadInvitationGroupInvitees/success',
);

export const deleteInvitationSourceInitialize = createAction(
  'api/hearing/deleteInvitationSource/init',
);
export const deleteInvitationSourceSuccess = createAction(
  'api/hearing/deleteInvitationSource/success',
);

export const deleteInvitationSourceMappingsInitialize = createAction(
  'api/hearing/deleteInvitationSourceMappings/init',
);
export const deleteInvitationSourceMappingsSuccess = createAction(
  'api/hearing/deleteInvitationSourceMappings/success',
);
export const removeInvitationSourceMappingsFromStore = createAction(
  'api/invitationSourceMappings/removeFromStore',
);
export const addInvitationSourceMappingsToStore = createAction(
  'api/invitationSourceMappings/addToStore',
);

// HearingStatusSlice
export const getAllHearingStatusInitialize = createAction(
  'api/hearingStatus/getAll/init',
);
export const getAllHearingStatusSuccess = createAction(
  'api/hearingStatus/getAll/success',
);

//HearingTemplateSlice
export const getAllHearingTemplatesInitialize = createAction(
  'api/hearingTemplate/getAll/init',
);
export const getAllHearingTemplatesSuccess = createAction(
  'api/hearingTemplate/getAll/success',
);
export const getAllHearingTemplatesError = createAction(
  'api/hearingTemplate/getAll/error',
);

// HearingTypeSlice
export const getAllHearingTypesInitialize = createAction(
  'api/hearingtype/getAll/init',
);
export const getAllHearingTypesSuccess = createAction(
  'api/hearingtype/getAll/success',
);
export const getAllHearingTypesError = createAction(
  'api/hearingtype/getAll/error',
);
export const updateHearingTypeInitialize = createAction(
  'api/hearingtype/update/init',
);
export const updateHearingTypeSuccess = createAction(
  'api/hearingtype/update/success',
);
export const updateHearingTypeError = createAction(
  'api/hearingtype/update/error',
);
export const deleteHearingTypeInitialize = createAction(
  'api/hearingtype/delete/init',
);
export const deleteHearingTypeSuccess = createAction(
  'api/hearingtype/delete/success',
);
export const createHearingTypeInitialize = createAction(
  'api/hearingtype/create/init',
);
export const createHearingTypeSuccess = createAction(
  'api/hearingtype/create/success',
);
export const createHearingTypeError = createAction(
  'api/hearingtype/create/error',
);

//KleHierarchy
export const getAllKleHierarchiesInitialize = createAction(
  'api/KleHierarchy/getAll/init',
);
export const getAllKleHierarchiesSuccess = createAction(
  'api/KleHierarchy/getAll/success',
);
export const getAllKleHierarchiesError = createAction(
  'api/KleHierarchy/getAll/error',
);

//KleMapping

export const updateKleMappingsInitialize = createAction(
  'api/KleMapping/update/init',
);
export const updateKleMappingsError = createAction(
  'api/KleMapping/update/error',
);
export const updateKleMappingsSuccess = createAction(
  'api/KleMapping/update/success',
);
export const addKleMappingsToStore = createAction('api/KleMapping/addToStore');
export const removeKleMappingsFromStore = createAction(
  'api/KleMapping/removeFromStore',
);

// CityAreaSlice
export const getAllCityAreasInitialize = createAction(
  'api/cityarea/getAll/init',
);
export const getAllCityAreasSuccess = createAction(
  'api/cityarea/getAll/success',
);
export const getAllCityAreasError = createAction('api/cityarea/getAll/error');
export const updateCityAreaInitialize = createAction(
  'api/cityArea/update/init',
);
export const updateCityAreaSuccess = createAction(
  'api/cityArea/update/success',
);
export const deleteCityAreaInitialize = createAction(
  'api/cityArea/delete/init',
);
export const deleteCityAreaSuccess = createAction(
  'api/cityArea/delete/success',
);
export const createCityAreaInitialize = createAction(
  'api/cityArea/create/init',
);
export const createCityAreaSuccess = createAction(
  'api/cityArea/create/success',
);

// SubjectAreaSlice
export const getAllSubjectAreasInitialize = createAction(
  'api/subjectarea/getAll/init',
);
export const getAllSubjectAreasSuccess = createAction(
  'api/subjectarea/getAll/success',
);
export const getAllSubjectAreasError = createAction(
  'api/subjectarea/getAll/error',
);
export const updateSubjectAreaInitialize = createAction(
  'api/subjectArea/update/init',
);
export const updateSubjectAreaSuccess = createAction(
  'api/subjectArea/update/success',
);
export const deleteSubjectAreaInitialize = createAction(
  'api/subjectArea/delete/init',
);
export const deleteSubjectAreaSuccess = createAction(
  'api/subjectArea/delete/success',
);
export const createSubjectAreaInitialize = createAction(
  'api/subjectArea/create/init',
);
export const createSubjectAreaSuccess = createAction(
  'api/subjectArea/create/success',
);

// HearingRoleSlice
export const getAllHearingRolesInitialize = createAction(
  'api/hearingRole/getAll/init',
);
export const getAllHearingRolesError = createAction(
  'api/hearingRole/getAll/error',
);
export const getAllHearingRolesSuccess = createAction(
  'api/hearingRole/getAll/success',
);

// UserHearingRoleSlice
export const createUserHearingRoleInitialize = createAction(
  'api/userHearingRole/create/init',
);
export const createUserHearingRoleSuccess = createAction(
  'api/userHearingRole/create/success',
);
export const deleteUserHearingRoleInitialize = createAction(
  'api/userHearingRole/delete/init',
);
export const deleteUserHearingRoleSuccess = createAction(
  'api/userHearingRole/delete/success',
);
export const removeUserHearingRolesFromStore = createAction(
  'api/userHearingRole/removeFromStore',
);
export const addUserHearingRolesToStore = createAction(
  'api/userHearingRole/addToStore',
);

// CompanyHearingRoleSlice
export const removeCompanyHearingRolesFromStore = createAction(
  'api/companyHearingRole/removeFromStore',
);
export const addCompanyHearingRolesToStore = createAction(
  'api/companyHearingRole/addToStore',
);

// UserSlice
export const getAllUsersInitialize = createAction('api/user/getAll/init');
export const getAllUsersSuccess = createAction('api/user/getAll/success');

// NotificationSlice
export const getInvitationNotificationsForHearingInitialize = createAction(
  'api/notification/getForHearing/init',
);
export const getInvitationNotificationsForHearingSuccess = createAction(
  'api/notification/getForHearing/success',
);
export const getInvitationNotificationsForHearingError = createAction(
  'api/notification/getForHearing/error',
);
export const sendNotificationInitialize = createAction(
  'api/notification/send/init',
);
export const sendNotificationSuccess = createAction(
  'api/notification/send/success',
);
export const sendNotificationError = createAction(
  'api/notification/send/error',
);

// NotificationContentSlice
export const updateNotificationContentInitialize = createAction(
  'api/notificationContentSpecification/update/notificationContent/init',
);
export const updateNotificationContentSuccess = createAction(
  'api/notificationContentSpecification/update/notificationContent/success',
);
export const updateNotificationContentError = createAction(
  'api/notificationContentSpecification/update/notificationContent/error',
);

// NotificationContentSpecificationSlice
export const getNotificationContentSpecificationForHearingInitialize = createAction(
  'api/notificationContentSpecification/getForHearing/init',
);
export const getNotificationContentSpecificationForHearingSuccess = createAction(
  'api/notificationContentSpecification/getForHearing/success',
);
export const getNotificationContentSpecificationForHearingError = createAction(
  'api/notificationContentSpecification/getForHearing/error',
);

// InvitationGroupSlice
export const getAllInvitationGroupsInitialize = createAction(
  'api/invitationGroup/getAll/init',
);
export const getAllInvitationGroupsSuccess = createAction(
  'api/invitationGroup/getAll/success',
);
export const getAllInvitationGroupsError = createAction(
  'api/invitationGroup/getAll/error',
);
export const createInvitationGroupInitialize = createAction(
  'api/invitationGroup/create/init',
);
export const createInvitationGroupSuccess = createAction(
  'api/invitationGroup/create/success',
);
export const createInvitationGroupError = createAction(
  'api/invitationGroup/create/error',
);
export const updateInvitationGroupInitialize = createAction(
  'api/invitationGroup/update/init',
);
export const updateInvitationGroupSuccess = createAction(
  'api/invitationGroup/update/success',
);
export const updateInvitationGroupError = createAction(
  'api/invitationGroup/update/error',
);
export const deleteInvitationGroupInitialize = createAction(
  'api/invitationGroup/delete/init',
);
export const deleteInvitationGroupSuccess = createAction(
  'api/invitationGroup/delete/success',
);
export const deleteInvitationGroupError = createAction(
  'api/invitationGroup/delete/error',
);

// InvitationGroupMappingSlice
export const updateInvitationGroupMappingsInitialize = createAction(
  'api/invitationGroupMappings/update/init',
);
export const updateInvitationGroupMappingsSuccess = createAction(
  'api/invitationGroupMappings/update/success',
);
export const addInvitationGroupMappingsToStore = createAction(
  'api/invitationGroupMappings/addToStore',
);
export const removeInvitationGroupMappingsFromStore = createAction(
  'api/invitationGroupMappings/removeFromStore',
);

// InvitationKeySlice
export const updateInvitationKeysInitialize = createAction(
  'api/invitationKeys/update/init',
);
export const updateInvitationKeysSuccess = createAction(
  'api/invitationKeys/update/success',
);
export const addInvitationKeysToStore = createAction(
  'api/invitationKeys/addToStore',
);
export const removeInvitationKeysFromStore = createAction(
  'api/invitationKeys/removeFromStore',
);

// InvitationSourceSlice
export const getAllInvitationSourcesInitialize = createAction(
  'api/invitationSource/getAll/init',
);
export const getAllInvitationSourcesSuccess = createAction(
  'api/invitationSource/getAll/success',
);
export const getAllInvitationSourcesError = createAction(
  'api/invitationSource/getAll/error',
);
